import $ from 'jquery'

$('.slider').slick({
    adaptiveHeight: true
});
